<script setup>
import { onMounted, ref, computed } from 'vue';
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import { searchStatuses } from '../../helpers/constants/index';
import store from '../../state/store';
import axios from 'axios';
import { authHeader } from '../../helpers/authservice/auth-header';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
import '@jobinsjp/vue3-datatable/dist/style.css';
import MediaViewer from '../../components/general-search/media-viewer.vue';
import ViolationInformation from '../../components/general-search/traffic-record/violation-information.vue';
import Violations from '../../components/general-search/traffic-record/violations.vue';
import LtoRecord from '../../components/general-search/traffic-record/lto-record.vue';
import Ovr from '../../components/general-search/ovr/ovr.vue';
import ViolationPenaltyMatrix from '../../components/general-search/ovr/violation-penalty-matrix.vue';
import Tracking from '../../components/general-search/tracking.vue';
import NovViewer from '../../components/general-search/nov-viewer.vue';
import Payment from '../../components/general-search/payment/payment.vue';
import OREditLogs from '../../components/general-search/payment/or-edit-logs.vue';
import Apprehension from '../../components/general-search/apprehension.vue';
import Timeline from '../../components/general-search/timeline.vue';
import InputViolation from '../../components/general-search/edit-record/input-violation.vue';
import Swal from 'sweetalert2';
import moment from 'moment';

const baseURL = computed(() => axios.defaults.baseURL);
const user = computed(() => JSON.parse(localStorage.getItem('user')));
const userRoles = computed(() => JSON.parse(localStorage.getItem('roles')));
const title = ref('General Search');
const items = ref([
  {
    text: "Home",
  },
    {
    text: "Search",
  },
  {
    text: "General Search",
    active: true,
  },
]);

const roleExist = (slug) => {
  if (userRoles.value && userRoles.value.length) {
      return userRoles.value.some((obj) => (obj.slug === slug));
  }

  return false;
}

const resetSearchParams = () => {
  searchStatus.value = 'all';
  searchParams.value = {
    file_name: '',
    lgu_id: '',
    camera_id: '',
    nov: '',
    ovr: '',
    v_date_from: '',
    v_date_to: '',
    u_date_from: '',
    u_date_to: '',
    owner_name: '',
    owner_address: '',
    mv_file_number: '',
    conduction_sticker: '',
    plate_number: '',
    registration_number: '',
    or_number: ''
  }
}

const submitted = ref(false);

const humanfriendlyConfig = ref({
  altInput: true,
  altFormat: "F j, Y",
  dateFormat: "Y-m-d"
});

const lgus = ref({});

const cameras = ref({});

const isClicked = ref(false);

const getLGUsAndCameras = async () => {
  try {
    const response = await axios.get(`search/user/${user.value.id}/lgus-and-cameras`, {
      headers: authHeader()
    })

    lgus.value = response.data.data.lgus;
    cameras.value = response.data.data.cameras;

  } catch (err) {
    console.log(err);
  }
}

const loading = computed(() => store.state.globals.loading);

const searchStatus = ref('all')

const searchResults = ref([]);

const pagination = ref({
  per_page: 5,
  total: 0,
  page: 1
})

const searchParams = ref({
  file_name: '',
  lgu_id: '',
  camera_id: '',
  nov: '',
  ovr: '',
  v_date_from: '',
  v_date_to: '',
  u_date_from: '',
  u_date_to: '',
  owner_name: '',
  owner_address: '',
  mv_file_number: '',
  conduction_sticker: '',
  plate_number: '',
  registration_number: '',
  or_number: ''
});

const refreshData = async (file_name) => {
  if (!file_name) return;

  try {
    await clickSearch(pagination.value);
    await showTabs(file_name);
  } catch (err) {
    console.log(err);
  }
}

const clickSearch = async (dt) => {
  if (dt.per_page) {
    pagination.value.per_page = dt.per_page;
  }

  store.dispatch('globals/loading', null, { root: true });
  searchResults.value = [];
  reset();

  try {
    const response = await axios.get(`search/${searchStatus.value}`, {
      headers: authHeader(),
      params: { ...searchParams.value,
        page: dt.page,
        page_size: pagination.value.per_page
      }
    })

    pagination.value.page =  response.data.current_page;
    pagination.value.total = response.data.total;
    if (response.data.per_page) {
      pagination.value.per_page = response.data.per_page;
    }

    let arraySearch = [];
    if (response.data.data) {
      arraySearch = Object.values(response.data.data)
    }

    if (arraySearch.length) {
      searchResults.value = Object.values(response.data.data);
    }

    submitted.value = true;
    window.scrollTo(0, 0);
    store.dispatch('globals/loaded', null, { root: true });
  } catch (err) {
    console.log(err);
    submitted.value = true;
    window.scrollTo(0, 0);
    store.dispatch('globals/loaded', null, { root: true });
  }
}

const selectedFileName = ref(null);
const selectedFile = ref({});

const showTabs = async (file_name) => {
  store.dispatch('globals/loading', null, { root: true });

  try {
    isClicked.value = true;

    if (searchResults.value.length) {
      selectedFileName.value = file_name;
      selectedFile.value = searchResults.value.find((result) => file_name === result.traffic_record.filename);
    }
    store.dispatch('globals/loaded', null, { root: true });
  } catch (err) {
    console.log(err);
  }
}

const reset = () => {
  isClicked.value = false;
  selectedFileName.value = null;
  selectedFile.value = {};
}

const searchMVFileNumber = (mv_file_number) => {
  searchParams.value.mv_file_number = mv_file_number
  clickSearch({ per_page: 1000, page: 1, total: pagination.value.total })
}

const fileName = ref(null);

const current_owner_name = ref(null);
const current_owner_address = ref(null);
const current_plate_no = ref(null);
const current_mv_file_no = ref(null);
const current_series = ref(null);
const current_year_model = ref(null);
const current_classification = ref(null);
const current_body_type = ref(null);
const current_make = ref(null);
const current_reject_reason_id = ref(null);
const current_other_reject_reason = ref(null);


const resetEditRecord = () => {
  current_owner_name.value = null;
  current_owner_address.value = null;
  current_plate_no.value = null;
  current_mv_file_no.value = null;
  current_series.value = null;
  current_year_model.value = null;
  current_classification.value = null;
  current_body_type.value = null;
  current_make.value = null;
  current_reject_reason_id.value = null;
  current_other_reject_reason.value = null;
  violation_list.value = [];
  editRecord.value = {
    id: null,
    camera_upload_id: null,
    filename: null,
    camera_type_folder_directory: null,
    year_directory: null,
    month_directory: null,
    day_directory: null,
    camera_id_directory: null,
    lane: null,
    location: null,
    location_code: null,
    speed_limit: null,
    speed_limit_car: null,
    speed_limit_truck: null,
    speed_limit_units: null,
    timestamp: null,
    vehicle_speed: null,
    vehicle_speed_units: null,
    vehicle_speed_unrounded: null,
    motor_vehicle_type: null,
    motor_vehicle_type_id: null,
    camera_id: null,
    camera_version: null,
    phase: null,
    phase_change_time: null,
    phase_id: null,
    minor_type: null,
    violation: null,
    registration_number: null,
    registration_type_id: null,
    is_rejected: null,
    is_whitelisted: null,
    whitelisted_date: null,
    reject_reason: null,
    reject_reason_id: null,
    rejected_date: null,
    other_reject_reason: null,
    lgu_approved: 1,
    lgu_approved_date: null,
    is_voided: null,
    voided_date: null,
    evaluator_user_id: null,
    remarks: null,
    plate_number_img: null,
    plate_number_img_upload_date: null,
    input_plate_no_tries: null,
    verify_tries: null,
    validate_tries: null,
    lgu_approved_tries: null,
    created_at: null,
    updated_at: null,
    is_paid: null,
    is_payment_queue: null,
    xml_phase: null,
    timeline: [],
    traffic_status: null,
    vehicle_record: [
      {
          id: null,
          traffic_record_id: null,
          selected: null,
          api_from: null,
          current_owner_name: null,
          current_owner_address: null,
          city_id: null,
          city_name: null,
          incomplete_address:null,
          plate_number: null,
          file_number: null,
          conduction_number: null,
          series: null,
          year_model: null,
          classification: null,
          body_type: null,
          make: null,
          original_owner_name: null,
          original_owner_address: null,
          raw: null,
          created_at: null,
          updated_at: null,
          api_interactor_id: null,
          has_vehicle_record: null,
        }
    ],
    ordinance_violation_reciept: {
        id: null,
        user_id: null,
        lgu_id: null,
        traffic_record_id: null,
        batch_id: null,
        traffic_record_violation_penalty_id: null,
        signature: null,
        number: null,
        is_auto: null,
        deleted_at: null,
        created_at: null,
        updated_at: null
    },
    violation_penalties: [
    {
        id: null,
        batch_id: null,
        traffic_record_id: null,
        violation_penalty_id: null,
        amount: null,
        status: null,
        generated_pdf_file: null,
        generated_pdf_date: null,
        notice_of_violation_number: null,
        pin: null,
        created_at: null,
        updated_at: null,
        generated_pdf_file_link: null,
        violation_penalty: {
            id: null,
            violation_id: null,
            name: null,
            article: null,
            offense_number: null,
            penalty_fee: null,
            created_at: null,
            updated_at: null
        }
      }
    ],
    media: []
  }
}

// EDIT MODAL
const editRecord = ref({
  id: null,
  camera_upload_id: null,
  filename: null,
  camera_type_folder_directory: null,
  year_directory: null,
  month_directory: null,
  day_directory: null,
  camera_id_directory: null,
  lane: null,
  location: null,
  location_code: null,
  speed_limit: null,
  speed_limit_car: null,
  speed_limit_truck: null,
  speed_limit_units: null,
  timestamp: null,
  vehicle_speed: null,
  vehicle_speed_units: null,
  vehicle_speed_unrounded: null,
  motor_vehicle_type: null,
  motor_vehicle_type_id: null,
  camera_id: null,
  camera_version: null,
  phase: null,
  phase_change_time: null,
  phase_id: null,
  minor_type: null,
  violation: null,
  registration_number: null,
  registration_type_id: null,
  is_rejected: null,
  is_whitelisted: null,
  whitelisted_date: null,
  reject_reason: null,
  reject_reason_id: null,
  rejected_date: null,
  other_reject_reason: null,
  lgu_approved: 1,
  lgu_approved_date: null,
  is_voided: null,
  voided_date: null,
  evaluator_user_id: null,
  remarks: null,
  plate_number_img: null,
  plate_number_img_upload_date: null,
  input_plate_no_tries: null,
  verify_tries: null,
  validate_tries: null,
  lgu_approved_tries: null,
  created_at: null,
  updated_at: null,
  is_paid: null,
  is_payment_queue: null,
  xml_phase: null,
  timeline: [],
  traffic_status: null,
  vehicle_record: [
    {
        id: null,
        traffic_record_id: null,
        selected: null,
        api_from: null,
        current_owner_name: null,
        current_owner_address: null,
        city_id: null,
        incomplete_address:null,
        plate_number: null,
        file_number: null,
        conduction_number: null,
        series: null,
        year_model: null,
        classification: null,
        body_type: null,
        make: null,
        original_owner_name: null,
        original_owner_address: null,
        raw: null,
        created_at: null,
        updated_at: null,
        api_interactor_id: null,
        has_vehicle_record: null,
      }
  ],
  ordinance_violation_reciept: {
      id: null,
      user_id: null,
      lgu_id: null,
      traffic_record_id: null,
      batch_id: null,
      traffic_record_violation_penalty_id: null,
      signature: null,
      number: null,
      is_auto: null,
      deleted_at: null,
      created_at: null,
      updated_at: null
  },
  violation_penalties: [
  {
      id: null,
      batch_id: null,
      traffic_record_id: null,
      violation_penalty_id: null,
      amount: null,
      status: null,
      generated_pdf_file: null,
      generated_pdf_date: null,
      notice_of_violation_number: null,
      pin: null,
      created_at: null,
      updated_at: null,
      generated_pdf_file_link: null,
      violation_penalty: {
          id: null,
          violation_id: null,
          name: null,
          article: null,
          offense_number: null,
          penalty_fee: null,
          created_at: null,
          updated_at: null
      }
    }
  ],
  media: []
});

const resetVoidRecord = () => {
  void_lto_record_information.value = null;
  void_violation_information.value = null;
  void_violations.value = null;
  note.value = null;
  attachment.value = null;
  attachmentRef.value = null;
  lift_reason_id.value = 1;
  voidRecord.value = 
    {
      id: null,
      camera_upload_id: null,
      filename: null,
      camera_type_folder_directory: null,
      year_directory: null,
      month_directory: null,
      day_directory: null,
      camera_id_directory: null,
      lane: null,
      location: null,
      location_code: null,
      speed_limit: null,
      speed_limit_car: null,
      speed_limit_truck: null,
      speed_limit_units: null,
      timestamp: null,
      vehicle_speed: null,
      vehicle_speed_units: null,
      vehicle_speed_unrounded: null,
      motor_vehicle_type: null,
      motor_vehicle_type_id: null,
      camera_id: null,
      camera_version: null,
      phase: null,
      phase_change_time: null,
      phase_id: null,
      minor_type: null,
      violation: null,
      registration_number: null,
      registration_type_id: null,
      is_rejected: null,
      is_whitelisted: null,
      whitelisted_date: null,
      reject_reason: null,
      reject_reason_id: 0,
      other_reject_reason: null,
      rejected_date: null,
      lgu_approved: null,
      lgu_approved_date: null,
      evaluator_user_id: null,
      remarks: null,
      plate_number_img: null,
      plate_number_img_upload_date: null,
      input_plate_no_tries: null,
      verify_tries: null,
      validate_tries: null,
      lgu_approved_tries: null,
      created_at: null,
      updated_at: null,
      is_voided: null,
      voided_date: null,
      is_paid: null,
      is_payment_queue: null,
      xml_phase: null,
      vehicle_record: [
          {
              id: null,
              traffic_record_id: null,
              selected: null,
              api_from: null,
              current_owner_name: null,
              current_owner_address: null,
              city_id: null,
              incomplete_address: null,
              plate_number: null,
              file_number: null,
              conduction_number: null,
              series: null,
              year_model:null,
              classification: null,
              body_type: null,
              make: null,
              original_owner_name: null,
              original_owner_address: null,
              raw: null,
              created_at: null,
              updated_at: null,
              api_interactor_id: null,
              has_vehicle_record: null,
          }
      ],
      violation_penalties: [
          {
              id: null,
              batch_id: null,
              traffic_record_id: null,
              violation_penalty_id: null,
              amount: null,
              status: null,
              generated_pdf_file: null,
              generated_pdf_date: null,
              notice_of_violation_number: null,
              pin: null,
              created_at: null,
              updated_at: null,
              generated_pdf_file_link: null,
              violation_penalty: {
                  id: null,
                  violation_id: null,
                  name: null,
                  article: null,
                  offense_number: null,
                  penalty_fee: null,
                  created_at: null,
                  updated_at: null
              }
          }
      ]
    }
}

const voidRecord = ref(
  {
    id: null,
    camera_upload_id: null,
    filename: null,
    camera_type_folder_directory: null,
    year_directory: null,
    month_directory: null,
    day_directory: null,
    camera_id_directory: null,
    lane: null,
    location: null,
    location_code: null,
    speed_limit: null,
    speed_limit_car: null,
    speed_limit_truck: null,
    speed_limit_units: null,
    timestamp: null,
    vehicle_speed: null,
    vehicle_speed_units: null,
    vehicle_speed_unrounded: null,
    motor_vehicle_type: null,
    motor_vehicle_type_id: null,
    camera_id: null,
    camera_version: null,
    phase: null,
    phase_change_time: null,
    phase_id: null,
    minor_type: null,
    violation: null,
    registration_number: null,
    registration_type_id: null,
    is_rejected: null,
    is_whitelisted: null,
    whitelisted_date: null,
    reject_reason: null,
    reject_reason_id: 0,
    other_reject_reason: null,
    rejected_date: null,
    lgu_approved: null,
    lgu_approved_date: null,
    evaluator_user_id: null,
    remarks: null,
    plate_number_img: null,
    plate_number_img_upload_date: null,
    input_plate_no_tries: null,
    verify_tries: null,
    validate_tries: null,
    lgu_approved_tries: null,
    created_at: null,
    updated_at: null,
    is_voided: null,
    voided_date: null,
    is_paid: null,
    is_payment_queue: null,
    xml_phase: null,
    vehicle_record: [
        {
            id: null,
            traffic_record_id: null,
            selected: null,
            api_from: null,
            current_owner_name: null,
            current_owner_address: null,
            city_id: null,
            incomplete_address: null,
            plate_number: null,
            file_number: null,
            conduction_number: null,
            series: null,
            year_model:null,
            classification: null,
            body_type: null,
            make: null,
            original_owner_name: null,
            original_owner_address: null,
            raw: null,
            created_at: null,
            updated_at: null,
            api_interactor_id: null,
            has_vehicle_record: null,
        }
    ],
    violation_penalties: [
        {
            id: null,
            batch_id: null,
            traffic_record_id: null,
            violation_penalty_id: null,
            amount: null,
            status: null,
            generated_pdf_file: null,
            generated_pdf_date: null,
            notice_of_violation_number: null,
            pin: null,
            created_at: null,
            updated_at: null,
            generated_pdf_file_link: null,
            violation_penalty: {
                id: null,
                violation_id: null,
                name: null,
                article: null,
                offense_number: null,
                penalty_fee: null,
                created_at: null,
                updated_at: null
            }
        }
    ]
  }
);

const editRecordTab = ref(0);

const getEditRecord = async (traffic_record_id) => {
  store.dispatch('globals/loading', null, { root: true });

  editRecordTab.value = 0;

  try {
    const { data } = await axios.get('/edit_violation', {
      headers: authHeader(),
      params: {
        traffic_record_id
      }
    })

    if (data.data.length) {
      editRecord.value = data.data[0];
      current_owner_name.value = data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].current_owner_name : '';
      current_owner_address.value = data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].current_owner_address : '';
      current_plate_no.value = data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].plate_number : '';
      current_mv_file_no.value = data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].file_number : '';
      current_series.value = data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].series : '';
      current_year_model.value = data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].year_model : '';
      current_classification.value = data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].classification : '';
      current_body_type.value = data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].body_type : '';
      current_make.value = data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].make : '';
      current_reject_reason_id.value = data.data[0].reject_reason_id ? data.data[0].reject_reason_id : "0";
      current_other_reject_reason.value = data.data[0].other_reject_reason ? data.data[0].other_reject_reason : "";

      await getViolationList(traffic_record_id);
    }

    store.dispatch('globals/loaded', null, { root: true });
  } catch (err) {
    console.log(err);
    store.dispatch('globals/loaded', null, { root: true });
  }
}

const void_violation_information = ref(null);
const void_lto_record_information = ref(null);
const void_violations = ref(null);

const getVoidRecord = async (traffic_record_id) => {
  store.dispatch('globals/loading', null, { root: true });
  
  try {
    const { data } = await axios.get('/void/get-one', {
      headers: authHeader(),
      params: {
        traffic_record_id
      }
    })

    if (data.data.length) {
      voidRecord.value = data.data[0];
      void_violation_information.value = {
        date: moment(data.data[0].timestamp).format('MMMM DD, YYYY'),
        time: moment(data.data[0].timestamp).format('hh:mm:ss A'),
        location: data.data[0].location,
        city: data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].city_name || null : null,
        lgu:  data.data[0].camera && data.data[0].camera.lgu ? data.data[0].camera.lgu.name : null,
        camera_id: data.data[0].camera_id,
        lane: data.data[0].lane
      }

      void_lto_record_information.value = {
        plate_number: data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].plate_number || null : null,
        mv_file_number: data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].file_number || null : null,
        series: data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].series || null : null,
        year_model: data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].year_model || null : null,
        classification: data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].classification || null : null,
        body_type: data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].body_type || null : null,
        owner_name: data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].current_owner_name || null : null,
        owner_address: data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].current_owner_address || null : null,
        make: data.data[0].vehicle_record.length ? data.data[0].vehicle_record[0].make || null : null,
      }

      void_violations.value = [{
        name: data.data[0].violation_penalties.length ? data.data[0].violation_penalties[0].violation_penalty.name || null : null,
        penalty_fee: data.data[0].violation_penalties.length ? data.data[0].violation_penalties[0].violation_penalty.penalty_fee || null : null,
    }]

      if (data.data[0].void) {
        note.value = data.data[0].void.note ? data.data[0].void.note : null;
        lift_reason_id.value = data.data[0].void.lift_reason_id;
      }
    }

    store.dispatch('globals/loaded', null, { root: true });
  } catch (err) {
    console.log(err);
    store.dispatch('globals/loaded', null, { root: true });
  }
}

const violation_list = ref([]);
const reject_reasons_list = ref([]);

const getViolationList = async (traffic_record_id) => {
  try {
    const { data } = await axios.get(`/traffic_record_component/violation_penalty/violation-penalty-list/${traffic_record_id}`, {
        headers: authHeader()
    });
    violation_list.value = data.data;
  } catch (err) {
    console.log(err)
  }
}

const getRejectReasonsList = async () => {
   try {
    const { data } = await axios.get(`/traffic_record_component/save_or_reject/reject-reason-list`, {
        headers: authHeader()
    });
    reject_reasons_list.value = data.data;
  } catch (err) {
    console.log(err)
  }
}

const returnPhase = async (slug) => {
  if(!editRecord.value.id) {
    Swal.fire("Error", `Traffic Record not found`, 'error');
    return;
  }

  let title = '';
  let text = '';
  let success = '';
  if (slug === 'send-to-input-phase') {
    title = 'Send to Input Phase';
    text = 'Continue sending this traffic record to input phase?';
    success = 'Successfully sent the traffic record to input phase.'
  }

  if (slug === 'send-to-verify-phase') {
    title = 'Send to Verify Phase';
    text = 'Continue sending this traffic record to verify phase?';
    success = 'Successfully sent the traffic record to verify phase.'
  }

  if (slug === 'send-to-validate-phase') {
    title = 'Send to Validate Reject';
    text = 'Continue sending this traffic record to validate phase?';
    success = 'Successfully sent the traffic record to validate phase.'
  }

  if (slug === 'resend-to-approval-queue') {
    title = 'Resend to Approval Queue';
    text = 'Continue re-sending this traffic record to approval queue?';
    success = 'Successfully resend the traffic record to approval queue.'
  }

  if (slug === 'send-to-phase-reject') {
    title = 'Send to Validate Reject';
    text = 'Continue sending this traffic record to validate reject?';
    success = 'Successfully sent the traffic record to validate reject.'
    if (!current_reject_reason_id.value || current_reject_reason_id.value == "0") {
      Swal.fire("Error", `Please Select Reject Reason`, 'error');
      return;
    }
  }

  const confirm = await Swal.fire({
      icon: 'warning',
      title,
      text,
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: 'Yes',
  })

  if (!confirm.isConfirmed) {
    return;
  }

  store.dispatch('globals/loading', null, { root: true });

  try {
    await axios.put(`/return_phase/${slug}`, null, {
      params: {
        traffic_status: editRecord.value.traffic_status,
        traffic_record_id: editRecord.value.id,
        reject_reason_id: current_reject_reason_id.value,
        other_reject_reason: current_other_reject_reason.value
      },
      headers: authHeader()
    })

    Swal.fire(
      "Success", 
      `${success} Kindly search it again.`, 
      "success").then(async (result) => {
          if (result.value) {
              await clickSearch(pagination.value);
              await getEditRecord(editRecord.value.id);
              store.dispatch('globals/loaded', null, { root: true });
          }
      });
  } catch (err) {
    console.log(err);
    const { message } = err.response.data;
    store.dispatch('globals/loaded', null, { root: true });
    Swal.fire("Error", message, 'error');
  }
}
// const getRejectReasonName = (reject_reason_id) => {
//     if (reject_reasons_list.value.length > 0) {
//       const lgu = reject_reasons_list.value.find((el) => el.id === reject_reason_id);
//       return lgu.name;
//     }
//     return '';
// }

const updateRejectReason = async () => {
  if(!editRecord.value.id) {
    Swal.fire("Error", `Traffic Record not found!`, 'error');
    return;
  }

  if (!current_reject_reason_id.value || current_reject_reason_id.value == "0") {
    Swal.fire("Error", `Please Select Reject Reason`, 'error');
    return;
  }

  const confirm = await Swal.fire({
      icon: 'warning',
      title: 'Update Reject Reason',
      text: 'Continue updating the reject reason? ',
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: 'Yes',
  })

  if (!confirm.isConfirmed) {
    return;
  }

  store.dispatch('globals/loading', null, { root: true });

  try {
    await axios.put('/edit_violation/update-reject-reason', null, {
      params: {
        _method: 'PUT',
        traffic_record_id: editRecord.value.id,
        reject_reason_id: current_reject_reason_id.value,
        other_reject_reason: current_other_reject_reason.value
      },
      headers: authHeader()
    })

    Swal.fire(
      "Success", 
      "Successfully updated the reject reason!", 
      "success").then(async (result) => {
          if (result.value) {
              await clickSearch(pagination.value);
              store.dispatch('globals/loaded', null, { root: true });
          }
    });
    store.dispatch('globals/loaded', null, { root: true });
    await clickSearch(pagination.value);
  } catch (err) {
    console.log(err);
    const { message } = err.response.data;
    store.dispatch('globals/loaded', null, { root: true });
    Swal.fire("Error", message, 'error');
  }
}

const updateOwnerInfo = async () => {
  if(!editRecord.value.id) {
    Swal.fire("Error", `Traffic Record not found!`, 'error');
    return;
  }

  if (!current_owner_name.value) {
    Swal.fire("Error", 'Owner name is required!', 'error');
    return;
  }

  const confirm = await Swal.fire({
      icon: 'info',
      title: "Update Owners' Information",
      text: "Continue updating owners' information?",
      showCancelButton: true,
      confirmButtonText: 'Yes',
  })

  if (!confirm.isConfirmed) {
    return;
  }

  store.dispatch('globals/loading', null, { root: true });

  try {
    await axios.put('/edit_violation/owner-name', null, {
      params: {
        traffic_record_id: editRecord.value.id,
        current_owner_name: current_owner_name.value
      },
      headers: authHeader()
    })

    Swal.fire(
      "Success", 
      "Successfully updated the owners' information!", 
      "success").then(async (result) => {
          if (result.value) {
              await clickSearch(pagination.value);
              store.dispatch('globals/loaded', null, { root: true });
          }
      });
  } catch (err) {
    console.log(err);
    const { message, exception } = err.response.data;
    store.dispatch('globals/loaded', null, { root: true });
    Swal.fire("Error", message ? message : exception, 'error');
  }
}

const updateViolation = async (value) => {
  if (!value) {
    Swal.fire("Error", `Please select base violation!`, 'error');
    return;
  }

  if(!editRecord.value.id) {
    Swal.fire("Error", `Traffic Record not found!`, 'error');
    return;
  }

  if(!editRecord.value.vehicle_record.length) {
    Swal.fire("Error", `LTO Record not found!`, 'error');
    return;
  }

  store.dispatch('globals/loading', null, { root: true });

  const formData = new FormData();
  formData.append('traffic_record_id', editRecord.value.id);
  formData.append('violation_penalty_id', value);

  try {
    const { data } = await axios.post('/edit_violation', formData, {
      params: {
        _method: 'PUT'
      },
      headers: authHeader()
    })

    if (editRecord.value.violation_penalties.length) {
      editRecord.value.violation_penalties[0] = data.traffic_violation;
    }

    if (editRecord.value.vehicle_record.length) {
      editRecord.value.vehicle_record[0] = data.traffic;
    }

    Swal.fire(
      "Success", 
      "Successfully updated violation!", 
      "success").then(async (result) => {
          if (result.value) {
              await clickSearch(pagination.value);
              store.dispatch('globals/loaded', null, { root: true });
          }
      });
  } catch (err) {
    console.log(err);
    const { message } = err.response.data;
    store.dispatch('globals/loaded', null, { root: true });
    Swal.fire("Error", message, 'error');
  }
}

const note = ref(null);
const attachment = ref(null);
const lift_reason_id = ref(1);
const attachmentRef = ref(null);

const voidThisTrafficRecord = async () => {
  const confirm_message = !voidRecord.value.void ? `Do you want to void this traffic record?` : `Do you want to update the void traffic record?`;

  const confirm = await Swal.fire({
      icon: 'info',
      title: 'Are you sure?',
      text: confirm_message,
      showCancelButton: true,
      confirmButtonText: 'Yes',
  })

  if (!confirm.isConfirmed) {
    return;
  }

  if (!voidRecord.value.vehicle_record.length) {
    Swal.fire("Error", `LTO Record not found!`, 'error');
    return;
  }

  if (!voidRecord.value.id) {
    Swal.fire("Error", `Traffic Record not found!`, 'error');
    return;
  }

  if (!note.value) {
    Swal.fire("Error", `Reason/Note is required!`, 'error');
    return;
  }

  if(!attachment.value) {
    Swal.fire("Error", `Attachment is required!`, 'error');
    return;
  }

  if(!lift_reason_id.value) {
    Swal.fire("Error", `Lift Reason is required!`, 'error');
    return;
  }

  store.dispatch('globals/loading', null, { root: true });

  const formData = new FormData();
  formData.append('traffic_record_id', voidRecord.value.vehicle_record[0].traffic_record_id);
  formData.append('note', note.value);
  formData.append('lift_reason_id', lift_reason_id.value);
  formData.append('attachment', attachment.value);

  try {
    const { data } = await axios.post('/void', formData, {
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' }
    })

    const success_message = !voidRecord.value.void ?  `Successfully void the traffic record!` : `Successfully updated the voided traffic record!`;

     Swal.fire(
      "Success", 
      success_message,
      "success").then(async (result) => {
          if (result.value) {
            await clickSearch(pagination.value)
            voidRecord.value.void = {
              ...data.data, voided_by_user: user.value.name,
            }
            store.dispatch('globals/loaded', null, { root: true });
          }
      });
  } catch (err) {
    console.log(err);
    const { message } = err.response.data;
    store.dispatch('globals/loaded', null, { root: true });
    Swal.fire("Error", message, 'error');
  }
}

 const handleFileUpload = () => {
    attachment.value = attachmentRef.value.files[0];
  }

onMounted(async () => {
  await getLGUsAndCameras();
  await getRejectReasonsList()
  fileName.value.focus();
})
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-xl-3">
          <b-overlay :show="loading">
            <div class="card">
              <div class="card-header">
                <h3>General Search</h3>
              </div>
              <div class="card-body">
                <form @submit.prevent="clickSearch" action="">
                  <div class="mb-3 text-center">
                    <label for="search-status-*" class="form-label">Status</label>
                    <select v-model="searchStatus" class="form-select">
                      <option :id="`search-status-${status.id}`" v-for="status in searchStatuses" :key="status.id" :value="status.id">{{ status.name }}</option>
                    </select>
                  </div>
                  <div class="mb-3 text-center"  v-if="!(['all']).includes(searchStatus)">
                    <label for="violation_date" class="form-label">Date of Upload</label>
                    <div class="d-flex">
                      <flatPickr
                        id="date"
                        placeholder="From"
                        v-model="searchParams.u_date_from"
                        :config="humanfriendlyConfig"
                        class="form-control flatpickr-input mr-1"
                      ></flatPickr>
                      <flatPickr
                        id="date"
                        placeholder="To"
                        v-model="searchParams.u_date_to"
                        :config="humanfriendlyConfig"
                        class="form-control flatpickr-input ml-1"
                      ></flatPickr>
                    </div>
                  </div>
                  <div class="divider"></div>
                  <div class="mb-3 text-center">
                    <label for="fileName" class="form-label">Info</label>
                    <input ref="fileName" type="text" v-model="searchParams.file_name" class="form-control" id="fileName" placeholder="File #">
                  </div>
                  <div class="mb-3">
                    <input type="text" v-model="searchParams.nov" class="form-control" id="nov" placeholder="NOV">
                  </div>
                  <div class="mb-3">
                    <input type="text" v-model="searchParams.ovr" class="form-control" id="ovr" placeholder="OVR #">
                  </div>
                  <div class="mb-3 text-center">
                    <label for="lgu" class="form-label">LGU</label>
                    <select v-model="searchParams.lgu_id" class="form-select" id="lgu">
                      <option value="">All</option>
                      <option v-for="(lgu, name) in lgus" :value="name" :key="name">{{ lgu }}</option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <label for="camera" class="form-label">Camera ID</label>
                    <select v-model="searchParams.camera_id" class="form-select" id="camera">
                      <option value="">All</option>
                      <option v-for="(camera, name) in cameras" :value="name" :key="name">{{ name }} ({{ camera }})</option>
                    </select>
                  </div>
                  <div class="mb-3 text-center">
                    <label for="plate_no" class="form-label">MV File Record</label>
                    <input type="text" v-model="searchParams.plate_number" class="form-control" id="plate_no" placeholder="Plate #" />
                  </div>
                  <div class="mb-3 text-center">
                    <input type="text" v-model="searchParams.mv_file_number" class="form-control" id="mv_file_no" placeholder="MV File #" />
                  </div>
                  <div class="mb-3 text-center">
                    <input type="text" v-model="searchParams.conduction_sticker" class="form-control" id="conduction_sticker" placeholder="Conduction Sticker #" />
                  </div>
                  <div v-if="roleExist('lto-record')" class="mb-3 text-center">
                    <input type="text" v-model="searchParams.owner_name" class="form-control" id="owner_name" placeholder="Owner Name" />
                  </div>
                  <div v-if="roleExist('lto-record')" class="mb-3 text-center">
                    <input type="text" v-model="searchParams.owner_address" class="form-control" id="owner_address" placeholder="Owner Address" />
                  </div>
                  <div class="mb-3 text-center">
                    <label for="registration_number" class="form-label">Mismatch</label>
                    <input type="text" v-model="searchParams.registration_number" class="form-control" id="registration_number" placeholder="Registration number used in mismatch" />
                  </div>
                  <div class="mb-3 text-center">
                    <label for="payment" class="form-label">Payment</label>
                    <input type="text" v-model="searchParams.or_number" class="form-control" id="payment" placeholder="OR #" />
                  </div>
                  <div class="mb-3 text-center">
                    <label for="violation_date" class="form-label">Violation Date</label>
                    <div class="d-flex">
                      <flatPickr
                        id="date"
                        placeholder="From"
                        v-model="searchParams.v_date_from"
                        :config="humanfriendlyConfig"
                        class="form-control flatpickr-input mr-1"
                      ></flatPickr>
                      <flatPickr
                        id="date"
                        placeholder="To"
                        v-model="searchParams.v_date_to"
                        :config="humanfriendlyConfig"
                        class="form-control flatpickr-input ml-1"
                      ></flatPickr>
                    </div>
                  </div>
                  <div class="mb-3 text-center" v-if="(['all']).includes(searchStatus)">
                    <label for="violation_date" class="form-label">Date of Upload</label>
                    <div class="d-flex">
                      <flatPickr
                        id="date"
                        placeholder="From"
                        v-model="searchParams.u_date_from"
                        :config="humanfriendlyConfig"
                        class="form-control flatpickr-input mr-1"
                      ></flatPickr>
                      <flatPickr
                        id="date"
                        placeholder="To"
                        v-model="searchParams.u_date_to"
                        :config="humanfriendlyConfig"
                        class="form-control flatpickr-input ml-1"
                      ></flatPickr>
                    </div>
                  </div>
                  <div class="text-center mt-5">
                    <div class="text-muted mb-2">All the inputs are optional</div>
                    <button @click.prevent="resetSearchParams" type="button" class="btn btn-danger mr-3">
                      <i class="bx bx-reset mr-1 fs-16"></i>
                      Reset</button>
                    <button type="submit" class="btn btn-primary">
                      <i class="mdi mdi-home-search mr-1 fs-16"></i>
                      Search</button>
                  </div>
                </form>
              </div>
            </div>
          </b-overlay>
        </div>
         <div v-if="submitted" class="col-md-12 col-xl-9">
          <b-overlay :show="loading">
            <div class="card">
              <div class="card-header d-inline-flex">
                <a href="javascript:void(0)" @click="reset" v-if="selectedFileName" class="d-inline-block fs-20 text">
                  <i class="mdi mdi-arrow-left mr-3"></i>
                </a>
                <div class="d-flex w-100 justify-content-between">
                  <h4>{{ selectedFileName ? 'File #: ' + selectedFileName : 'Search results goes below' }}</h4>
                  <button v-if="selectedFileName" @click="refreshData(selectedFileName)" class="btn btn-sm btn-outline-secondary waves-effect waves-light shadow-none">
                    <i class="ri ri-refresh-line fs-21 align-middle"></i> Reload
                  </button>
                </div>
              </div>
              <div class="card-body">
                <div v-if="!isClicked">
                  <div v-if="searchResults.length >= 25" class="mb-3">
                    <div class="d-block">Total records found: {{ pagination.total }}</div>
                      <a :href="`${baseURL}/search/${searchStatus}?download=true&user_id=${user.id}&${Object.keys(searchParams).map(key => `${key}=${searchParams[key] !== null ? searchParams[key] : '' }`).join('&')}`" download target="_blank" class="btn btn-info btn-sm float-right np-btn">
                    <i class="mdi mdi-microsoft-excel align-middle mr-1 fs-5 text-white"></i>
                    Export data</a>
                  </div>
                  <data-table
                    :rows="searchResults"
                    :pagination="pagination"
                    striped
                    :loading="loading"
                    hoverable
                    @loadData="clickSearch"
                >
                      <template #thead>
                          <table-head>Status</table-head>
                          <table-head>File #</table-head>
                          <table-head v-if="roleExist('lto-record')">Owner</table-head>
                          <table-head>OVR #</table-head>
                          <table-head>NOV</table-head>
                          <table-head>Plate #</table-head>
                          <table-head>CS #</table-head>
                          <table-head>MV File #</table-head>
                          <table-head>Violation</table-head>
                          <table-head>Violation Date</table-head>
                          <table-head>Tracking #</table-head>
                          <table-head>Delivery Status</table-head>
                          <table-head>OR #</table-head>
                          <table-head>Apprehension</table-head>
                          <table-head v-if="roleExist('edit-record')"></table-head>
                      </template>

                      <template #tbody="{row}">
                          <table-body :class="(row.traffic_record.status.includes('Rejected')) ? 'fs-12 text-danger': (row.traffic_record.status.includes('Approved')) ? 'fs-12 text-success': 'fs-12'">
                                {{  row.traffic_record.status }} {{ row.traffic_record.status.includes('Rejected') ? 
                                                                    `${row.traffic_record.reject_reason ? 
                                                                      `(${row.traffic_record.reject_reason})` : ''}` 
                                                                        : '' }}
                          </table-body>
                          <table-body class="fs-12">
                            <span class="text-info text-underline" @click="showTabs(row.traffic_record.filename)">
                              {{ row.traffic_record.filename ? row.traffic_record.filename : '' }}
                            </span>
                          </table-body>
                          <table-body v-if="roleExist('lto-record')" class="fs-12">{{ row.traffic_record.lto_record.owner_name || '' }}</table-body>
                          <table-body class="fs-12">{{ row.ovr.ovr.ovr_number || '' }}</table-body>
                          <table-body class="fs-12">{{ row.nov && row.nov.id ? row.nov.id : '' }}</table-body>
                          <table-body class="fs-12">{{ row.traffic_record.lto_record.plate_number || '' }}</table-body>
                          <table-body class="fs-12">{{ row.traffic_record.lto_record.conduction_sticker || '' }}</table-body>
                          <table-body class="fs-12">
                            <span v-if="!row.traffic_record.lto_record.mv_file_number"></span>
                            <span v-else @click="searchMVFileNumber(row.traffic_record.lto_record.mv_file_number)">
                              <span class="d-block text-info text-underline">{{ row.traffic_record.lto_record.mv_file_number }}</span>
                              <span class="text-muted">(Click to view similar MV file number)</span>
                            </span>
                            </table-body>
                          <table-body :title="row.traffic_record.violations" class="fs-12">
                            <span v-for="(entry, index) in row.traffic_record.violations" :key="index">
                                {{ entry.name || '' }} <span v-if="index != Object.keys(row.traffic_record.violations).length - 1">, <br></span>
                            </span>
                          </table-body>
                          <table-body>{{ row.traffic_record.violation_information.date + ' ' + row.traffic_record.violation_information.time }}</table-body>
                          <table-body class="fs-12 text-center">
                            {{ row.tracking && row.tracking.tracking_number ? row.tracking.tracking_number : '' }}
                          </table-body>
                          <table-body class="fs-12">{{ row.tracking && row.tracking.last_entry_name ? row.tracking.last_entry_name : '' }}</table-body>
                          <table-body class="fs-12">{{ row.payment && row.payment.or_number ? row.payment.or_number : '' }}</table-body>
                          <table-body
                            class="fs-12">
                              <span class="text-success" v-if="row.apprehension.dermalog.has_alarm && row.apprehension.dermalog.alarm.status === 'Lifted' && row.apprehension.stradcom.has_alarm && row.apprehension.stradcom.alarm.status === 'Lifted'">
                                Dermalog & Stradcom - Lifted
                              </span>
                              <span class="text-danger" v-if="row.apprehension.dermalog.has_alarm && row.apprehension.dermalog.alarm.status === 'Active' && row.apprehension.stradcom.has_alarm && row.apprehension.stradcom.alarm.status === 'Active'">
                                Dermalog & Stradcom - Active
                              </span>
                              <span v-if="row.apprehension.dermalog.has_alarm && row.apprehension.dermalog.alarm.status === 'Lifted' && row.apprehension.stradcom.has_alarm && row.apprehension.stradcom.alarm.status === 'Active'">
                                <span class="d-block text-success">Dermalog - Lifted</span>
                                <span class="d-block text-danger">Stradcom - Active</span>
                              </span>
                              <span v-if="row.apprehension.dermalog.has_alarm && row.apprehension.dermalog.alarm.status === 'Active' && row.apprehension.stradcom.has_alarm && row.apprehension.stradcom.alarm.status === 'Lifted'">
                                <span class="d-block text-success">Dermalog - Active</span>
                                <span class="d-block text-danger">Stradcom - Lifted</span>
                              </span>
                              <span v-if="!row.apprehension.dermalog.has_alarm && row.apprehension.stradcom.has_alarm && row.apprehension.stradcom.alarm.status === 'Lifted'">
                                <span class="d-block text-success">Stradcom - Lifted</span>
                              </span>
                              <span v-if="!row.apprehension.dermalog.has_alarm && row.apprehension.stradcom.has_alarm && row.apprehension.stradcom.alarm.status === 'Active'">
                                <span class="d-block text-danger">Stradcom - Active</span>
                              </span>
                              <span v-if="!row.apprehension.stradcom.has_alarm && row.apprehension.dermalog.has_alarm && row.apprehension.dermalog.alarm.status === 'Lifted'">
                                <span class="d-block text-success">Dermalog - Lifted</span>
                              </span>
                              <span v-if="!row.apprehension.stradcom.has_alarm && row.apprehension.dermalog.has_alarm && row.apprehension.dermalog.alarm.status === 'Active'">
                                <span class="d-block text-danger">Dermalog - Active</span>
                              </span>
                              <span class="text-muted" v-if="!row.apprehension.dermalog.has_alarm  && !row.apprehension.stradcom.has_alarm">
                                
                              </span>
                              <span class="d-block text-muted" v-if="row.apprehension.dermalog.has_alarm || row.apprehension.stradcom.has_alarm">
                                (Txn ID: {{ row.apprehension.dermalog.alarm.transaction_id || row.apprehension.stradcom.alarm.transaction_id }})
                              </span>
                          </table-body>
                          <table-body v-if="roleExist('edit-record')" class="fs-12">
                            <!-- <button @click="getEditRecord(row.traffic_record.id)" type="button" class="btn btn-info btn-sm m-1" data-bs-toggle="modal" data-bs-target="#editRecordModal">
                              <i class="mdi mdi-pencil"></i>
                              Edit Page</button><br> -->
                            <button @click="getVoidRecord(row.traffic_record.id)" type="button" class="btn btn-danger btn-sm m-1" data-bs-toggle="modal" data-bs-target="#voidRecordModal">
                              <i class="mdi mdi-close"></i>
                              Void Page</button>
                          </table-body>
                      </template>

                      <template #empty>
                        <TableBodyCell colspan="15">
                            No search results found!
                        </TableBodyCell>
                    </template>
                  </data-table>

                    <div v-if="searchResults.length" class="">
                      <div class="d-block">Total records found: {{ pagination.total }}</div>
                     <a :href="`${baseURL}/search/${searchStatus}?download=true&user_id=${user.id}&${Object.keys(searchParams).map(key => `${key}=${searchParams[key] !== null ? searchParams[key] : '' }`).join('&')}`" download target="_blank" class="btn btn-info btn-sm float-right np-btn">
                    <i class="mdi mdi-microsoft-excel align-middle mr-1 fs-5 text-white"></i>
                    Export data</a>
                    </div>
                </div>
                <div v-else class="row">
                  <div class="col-md-12">
                    <b-tabs tag="ul" class="nav-primary nav-tabs-custom" content-class="mt-3">
                       <b-tab title="Media">
                        <div class="row">
                          <MediaViewer :medias="selectedFile.media" :traffic_record="selectedFile.traffic_record" />
                        </div>
                      </b-tab>
                      <b-tab title="Traffic Record" class="bg-light">
                        <div class="row gx-0">
                          <div class="col-md-12 col-lg-6">
                            <ViolationInformation :violation_information="selectedFile.traffic_record.violation_information" />
                            <Violations :violations="selectedFile.traffic_record.violations"/>
                          </div>
                          <div class="col-md-12 col-lg-6">
                              <LtoRecord :lto_record="selectedFile.traffic_record.lto_record" />
                          </div>
                        </div>
                      </b-tab>
                      <b-tab v-if="roleExist('lto-record')" title="NOV">
                        <div class="row">
                          <div class="col-md-12 mb-1">
                            <NovViewer :nov="selectedFile.nov" />
                          </div>
                        </div>
                      </b-tab>
                      <b-tab title="OVR" class="bg-light">
                        <div class="row gx-0">
                          <div class="col-md-12 col-lg-6">
                            <Ovr :ovr="selectedFile.ovr.ovr" />
                          </div>
                          <div class="col-md-12 col-lg-6">
                            <Violations :violations="selectedFile.ovr.violations"/>
                          </div>
                           <div class="col-md-12">
                            <ViolationPenaltyMatrix :violation_penalty_matrix="selectedFile.ovr.violation_penalty_matrix"/>
                          </div>
                        </div>
                      </b-tab>
                      <b-tab title="Tracking" class="bg-light">
                        <Tracking :tracking="selectedFile.tracking" />
                      </b-tab>
                      <b-tab title="Payment" class="bg-light">
                        <div class="row">
                          <div class="col-md-12">
                            <Payment :payment="selectedFile.payment" />
                          </div>
                          <div class="col-md-12">
                            <OREditLogs />
                          </div>
                        </div>
                      </b-tab>
                      <b-tab title="Apprehensions" class="bg-light">
                        <div class="row">
                          <div class="col-md-12">
                            <Apprehension
                              company="Dermalog"
                              :apprehension="selectedFile.apprehension.dermalog" />
                          </div>
                          <div class="col-md-12">
                            <Apprehension
                              company="Stradcom"
                              :apprehension="selectedFile.apprehension.stradcom" />
                          </div>
                        </div>
                      </b-tab>
                      <b-tab v-if="roleExist('timeline')" title="Timeline" class="bg-light">
                        <div class="row">
                          <div class="col-md-12">
                             <Timeline :timeline="selectedFile.timeline"/>
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
        <div v-else class="col-md-12 col-xl-9">
          <div class="card">
            <div class="card-body">
              <div class="text-center">
                  <div class="row justify-content-center">
                    <div class="col-lg-9">
                      <h2 class="mt-4 fw-semibold">Search</h2>
                      <p class="text-muted mt-3 fs-20">
                        Search results will show up here
                      </p>
                    </div>
                  </div>
                  <div class="row justify-content-center mt-5 mb-2">
                    <div class="col-sm-7 col-8">
                      <img src="@/assets/images/file.png" alt="" class="img-fluid">
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div id="editRecordModal" class="modal fade" data-bs-backdrop="static" tabindex="-1" aria-labelledby="editRecordModalLabel" aria-hidden="true" style="display: none;">
      <div class="modal-dialog modal-xl modal-fullscreen-lg-down">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editRecordModalLabel">Edit Record</h5>
            <button type="button" @click="resetEditRecord" class="btn-close" data-bs-dismiss="modal" aria-label="Close"> </button>
          </div>
          <div class="modal-body">
            <b-overlay :show="loading">
              <b-tabs v-model="editRecordTab" tag="ul" class="nav-success nav-tabs-custom pl-0" content-class="mt-3">
                <b-tab title="Details" class="bg-light" active>
                  <div class="row p-3">
                    <div class="col-md-12 col-xl-4">
                      <div class="card border-top card-border-info">
                        <div class="card-body">
                           <form action="">
                            <div class="mb-3">
                              <label class="form-label">File No.</label>
                              <span class="form-control bg-light">{{ editRecord.filename ? editRecord.filename : 'n/a'  }}</span>
                            </div>
                            <div class="mb-3">
                              <label class="form-label">NOV No.</label>
                              <span class="form-control bg-light">{{ editRecord.violation_penalties.length ? editRecord.violation_penalties[0].notice_of_violation_number || 'n/a' : 'n/a'  }}</span>
                            </div>
                            <div class="mb-3">
                              <label class="form-label">OVR No.</label>
                               <span class="form-control bg-light">{{ editRecord.ordinance_violation_reciept && editRecord.ordinance_violation_reciept.number ? editRecord.ordinance_violation_reciept.number : 'n/a'  }}</span>
                            </div>
                            <div class="mb-3">
                              <label class="form-label">Status</label>
                               <span class="form-control bg-light">{{ editRecord.traffic_status ? editRecord.traffic_status : 'n/a'  }}</span>
                            </div>
                            <template v-if="!(['INPUT PENDING', 'WARNING OVR', 'VOIDED', 'LGU APPROVED', 'INPUT PROCESSED', 'VERIFY PROCESSED', 'ON PROCESS']).includes(editRecord.traffic_status)">
                              <template v-if="(['VALIDATE PROCESSED', 'LGU PROCESSED']).includes(editRecord.traffic_status)">
                                <div class="my-1"><hr></div>
                                <div class="mb-3">
                                  <label class="form-label">Reject Reason</label>
                                  <select class="form-select" v-model="current_reject_reason_id">
                                      <option value="0">Select Reject Reason</option>
                                      <option :value="reject_reason.id" v-for="reject_reason in reject_reasons_list" :key="reject_reason.id">{{ reject_reason.name }}</option>
                                  </select>
                                </div>
                                <div class="mb-3">
                                  <label for="form-label">Other Reason</label>
                                  <input type="text" class="form-control" v-model="current_other_reject_reason" placeholder="Other reason here...">
                                </div>
                                <div class="mb-3 text-center">
                                  <button class="btn btn-danger" @click.prevent="returnPhase('send-to-phase-reject')">
                                    <i class="mdi mdi-arrange-send-to-back mr-1 align-middle"></i>
                                    Send to Validate Reject</button>  
                                </div>
                              </template>
                              <template v-if="(['INPUT REJECTED', 'VERIFY REJECTED', 'VALIDATE REJECTED']).includes(editRecord.traffic_status)">
                                <div class="my-1"><hr></div>
                                <div class="mb-3 text-center">
                                  <template v-if="(['INPUT REJECTED', 'VERIFY REJECTED']).includes(editRecord.traffic_status)">
                                    <button class="btn btn-info" @click.prevent="returnPhase('send-to-input-phase')">
                                      <i class="mdi mdi-arrange-send-to-back mr-1 align-middle"></i>
                                      Send to Input Phase</button>  
                                  </template>
                                  <template v-else>
                                    <button class="btn btn-info" @click.prevent="returnPhase('send-to-validate-phase')">
                                      <i class="mdi mdi-arrange-send-to-back mr-1 align-middle"></i>
                                      Send to Validate Phase</button>  
                                  </template>
                                </div>
                                <div class="my-1"><hr></div>
                                <div class="mb-3">
                                  <label class="form-label">Change Reject Reason</label>
                                  <select class="form-select" v-model="current_reject_reason_id">
                                      <option value="0">Select Reject Reason</option>
                                      <option :value="reject_reason.id" v-for="reject_reason in reject_reasons_list" :key="reject_reason.id">{{ reject_reason.name }}</option>
                                  </select>
                                </div>
                                <div class="mb-3 text-center">
                                  <button class="btn btn-info" @click.prevent="updateRejectReason">
                                    <i class="mdi mdi-content-save mr-1 align-middle"></i>
                                    Update Reject Reason</button>  
                                </div>
                              </template>
                              <template v-if="(['LGU REJECTED']).includes(editRecord.traffic_status)">
                                <div class="my-1"><hr></div>
                                <div class="mb-3">
                                  <label class="form-label">Change Reject Reason</label>
                                  <select class="form-select" v-model="current_reject_reason_id">
                                      <option value="0">Select Reject Reason</option>
                                      <option :value="reject_reason.id" v-for="reject_reason in reject_reasons_list" :key="reject_reason.id">{{ reject_reason.name }}</option>
                                  </select>
                                </div>
                                <div class="mb-3 text-center">
                                  <button class="btn btn-info" @click.prevent="updateRejectReason">
                                    <i class="mdi mdi-content-save mr-1 align-middle" ></i>
                                    Update Reject Reason</button>  
                                </div>
                                 <div class="my-1"><hr></div>
                                  <div class="mb-3 text-center">
                                  <button class="btn btn-danger" @click.prevent="returnPhase('resend-to-approval-queue')">
                                    <i class="mdi mdi-arrange-send-to-back mr-1 align-middle"></i>
                                    Resend to Approval Queue</button>  
                                </div>
                              </template>
                            </template>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 col-xl-8">
                      <div class="card border-top card-border-info">
                        <div class="card-header text-center">
                          <h4 class="card-title">Violation</h4>
                        </div>
                        <div class="card-body">
                            <template v-if="editRecord.violation_penalties.length && editRecord.violation_penalties[0].violation_penalty_id">
                              <InputViolation @save="updateViolation" :existingViolation="editRecord.violation_penalties[0].violation_penalty_id" :violation_list="violation_list" />
                           </template>
                           <template v-else>
                              <h5 class="text-center">No base violation to update!</h5>
                           </template>
                        </div>
                      </div>
                    </div>
                     <div class="col-md-12 col-xl-4">
                      <div class="card border-top card-border-info">
                        <div class="card-header">
                          <h4 class="card-title">NOV #: {{ editRecord.violation_penalties.length ? editRecord.violation_penalties[0].notice_of_violation_number || 'n/a' : 'n/a' }}</h4>
                        </div>
                        <div class="card-body">
                            <form action="">
                            <div v-if="roleExist('lto-record')" class="mb-3">
                              <label class="form-label">Owner Name</label>
                              <input type="text" class="form-control" v-model="current_owner_name" placeholder="Owner name here..."/>
                            </div>
                            <div v-if="roleExist('lto-record')" class="mb-3">
                              <label class="form-label">Owner Address</label>
                              <input type="text" :disabled="(['INPUT PENDING', 'INPUT ON PROCESS', 'INPUT REJECTED', 'ON PROCESS', 'VERIFY PROCESSED', 'VALIDATE ON PROCESS', 'VERIFY REJECTED', 'INPUT PROCESSED', 'VALIDATE REJECTED', 'LGU ON PROCESS', 'LGU PROCESSED', 'LGU APPROVED', 'VALIDATE PROCESSED', 'VOIDED', 'LGU REJECTED', 'VALIDATE PENDING']).includes(editRecord.traffic_status)" class="form-control" v-model="current_owner_address" placeholder="Owner address here..." />
                              <!-- <span class="form-control bg-light">{{ editRecord.vehicle_record.length ? editRecord.vehicle_record[0].current_owner_address || 'n/a' : 'n/a' }}</span> -->
                            </div>
                            <div class="mb-3">
                              <label class="form-label">Plate No.</label>
                              <input type="text" :disabled="(['INPUT PENDING', 'INPUT ON PROCESS', 'INPUT REJECTED', 'ON PROCESS', 'VERIFY PROCESSED', 'VALIDATE ON PROCESS', 'VERIFY REJECTED', 'INPUT PROCESSED', 'VALIDATE REJECTED', 'LGU ON PROCESS', 'LGU PROCESSED', 'LGU APPROVED', 'VALIDATE PROCESSED', 'VOIDED', 'LGU REJECTED', 'VALIDATE PENDING']).includes(editRecord.traffic_status)" class="form-control" v-model="current_plate_no" placeholder="Plate no. here..." />
                              <!-- <span class="form-control bg-light">{{ editRecord.vehicle_record.length ?editRecord.vehicle_record[0].plate_number || 'n/a' : 'n/a' }}</span> -->
                            </div>
                            <div class="mb-3">
                              <label class="form-label">MV File No.</label>
                              <input type="text" :disabled="(['INPUT PENDING', 'INPUT ON PROCESS', 'INPUT REJECTED', 'ON PROCESS', 'VERIFY PROCESSED', 'VALIDATE ON PROCESS', 'VERIFY REJECTED', 'INPUT PROCESSED', 'VALIDATE REJECTED', 'LGU ON PROCESS', 'LGU PROCESSED', 'LGU APPROVED', 'VALIDATE PROCESSED', 'VOIDED', 'LGU REJECTED', 'VALIDATE PENDING']).includes(editRecord.traffic_status)" class="form-control" v-model="current_mv_file_no" placeholder="MV file no. here..." />
                              <!-- <span class="form-control bg-light">{{ editRecord.vehicle_record.length ? editRecord.vehicle_record[0].file_number || 'n/a' : 'n/a' }}</span> -->
                            </div>
                            <div class="mb-3">
                              <label class="form-label">Series</label>
                              <input type="text" :disabled="(['INPUT PENDING', 'INPUT ON PROCESS', 'INPUT REJECTED', 'ON PROCESS', 'VERIFY PROCESSED', 'VALIDATE ON PROCESS', 'VERIFY REJECTED', 'INPUT PROCESSED', 'VALIDATE REJECTED', 'LGU ON PROCESS', 'LGU PROCESSED', 'LGU APPROVED', 'VALIDATE PROCESSED', 'VOIDED', 'LGU REJECTED', 'VALIDATE PENDING']).includes(editRecord.traffic_status)" class="form-control" v-model="current_series" placeholder="Series here..." />
                              <!-- <span class="form-control bg-light">{{ editRecord.vehicle_record.length ? editRecord.vehicle_record[0].series || 'n/a' : 'n/a' }}</span> -->
                            </div>
                            <div class="mb-3">
                              <label class="form-label">Year Model</label>
                              <input type="text" :disabled="(['INPUT PENDING', 'INPUT ON PROCESS', 'INPUT REJECTED', 'ON PROCESS', 'VERIFY PROCESSED', 'VALIDATE ON PROCESS', 'VERIFY REJECTED', 'INPUT PROCESSED', 'VALIDATE REJECTED', 'LGU ON PROCESS', 'LGU PROCESSED', 'LGU APPROVED', 'VALIDATE PROCESSED', 'VOIDED', 'LGU REJECTED', 'VALIDATE PENDING']).includes(editRecord.traffic_status)" class="form-control" v-model="current_year_model" placeholder="Year model here..." />
                              <!-- <span class="form-control bg-light">{{ editRecord.vehicle_record.length ? editRecord.vehicle_record[0].year_model || 'n/a' : 'n/a' }}</span> -->
                            </div>
                             <div class="mb-3">
                              <label class="form-label">Classification</label>
                              <input type="text" :disabled="(['INPUT PENDING', 'INPUT ON PROCESS', 'INPUT REJECTED', 'ON PROCESS', 'VERIFY PROCESSED', 'VALIDATE ON PROCESS', 'VERIFY REJECTED', 'INPUT PROCESSED', 'VALIDATE REJECTED', 'LGU ON PROCESS', 'LGU PROCESSED', 'LGU APPROVED', 'VALIDATE PROCESSED', 'VOIDED', 'LGU REJECTED', 'VALIDATE PENDING']).includes(editRecord.traffic_status)" class="form-control" v-model="current_classification" placeholder="Classification here..." />
                              <!-- <span class="form-control bg-light">{{ editRecord.vehicle_record.length ? editRecord.vehicle_record[0].classification || 'n/a' : 'n/a' }}</span> -->
                            </div>
                            <div class="mb-3">
                              <label class="form-label">Body Type</label>
                              <input type="text" :disabled="(['INPUT PENDING', 'INPUT ON PROCESS', 'INPUT REJECTED', 'ON PROCESS', 'VERIFY PROCESSED', 'VALIDATE ON PROCESS', 'VERIFY REJECTED', 'INPUT PROCESSED', 'VALIDATE REJECTED', 'LGU ON PROCESS', 'LGU PROCESSED', 'LGU APPROVED', 'VALIDATE PROCESSED', 'VOIDED', 'LGU REJECTED', 'VALIDATE PENDING']).includes(editRecord.traffic_status)" class="form-control" v-model="current_body_type" placeholder="Body type here..." />
                              <!-- <span class="form-control bg-light">{{ editRecord.vehicle_record.length ? editRecord.vehicle_record[0].body_type || 'n/a' : 'n/a' }}</span> -->
                            </div>
                             <div class="mb-3">
                              <label class="form-label">Make</label>
                              <input type="text" :disabled="(['INPUT PENDING', 'INPUT ON PROCESS', 'INPUT REJECTED', 'ON PROCESS', 'VERIFY PROCESSED', 'VALIDATE ON PROCESS', 'VERIFY REJECTED', 'INPUT PROCESSED', 'VALIDATE REJECTED', 'LGU ON PROCESS', 'LGU PROCESSED', 'LGU APPROVED', 'VALIDATE PROCESSED', 'VOIDED', 'LGU REJECTED', 'VALIDATE PENDING']).includes(editRecord.traffic_status)" class="form-control" v-model="current_make" placeholder="Make here..." />
                              <!-- <span class="form-control bg-light">{{ editRecord.vehicle_record.length ? editRecord.vehicle_record[0].make || 'n/a' : 'n/a' }}</span> -->
                            </div>
                            <div class="mb-3">
                              <label class="form-label">Date</label>
                              <span class="form-control bg-light">{{ editRecord.timestamp ? moment(editRecord.timestamp).format('MMMM DD, YYYY') : 'n/a' }}</span>
                            </div>
                             <div class="mb-3">
                              <label class="form-label">Time</label>
                              <span class="form-control bg-light">{{ editRecord.timestamp ? moment(editRecord.timestamp).format('hh:mm:ss A') : 'n/a' }}</span>
                            </div>
                            <div class="mb-3">
                              <label class="form-label">Location</label>
                              <span class="form-control bg-light">{{ editRecord.location ? editRecord.location : 'n/a' }}</span>
                            </div>
                            <div class="mb-3">
                              <label class="form-label">City</label>
                              <span class="form-control bg-light">{{ editRecord.vehicle_record.length ? editRecord.vehicle_record[0].city_name || 'n/a' : 'n/a' }}</span>
                            </div>
                            <template v-if="editRecord.vehicle_record.length && !(['VOIDED', 'LGU APPROVED']).includes(editRecord.traffic_status)">
                              <div class="mb-4 text-center">
                                  <button class="btn btn-info" @click.prevent="updateOwnerInfo">
                                    <i class="mdi mdi-content-save mr-1 align-middle"></i>
                                    Save
                                  </button>
                                  <!-- No clear requirements-->
                                  <!-- <template>
                                    <span class="d-block mt-1">Manual Input MV file</span>  
                                    <span class="text-danger d-block">Upon saving this record will be put into pending approval</span>
                                  </template> -->
                              </div>
                            </template>
                            <!-- No clear requirements-->
                            <!-- <div class="mb-3">
                              <div class="text-muted">* Approved by QPAX</div>
                              <div class="text-muted">* Rejected by QPAX</div>
                              <div class="text-muted">* Pending approval</div>
                              <div class="text-muted">Are the only records that can be edited</div>
                            </div> -->
                          </form>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 col-xl-8">
                      <div class="card border-top card-border-info">
                        <div class="card-header text-center">
                          <h4 class="card-title">Media</h4>
                        </div>
                        <div class="card-body">
                            <template v-if="editRecord.media.length">
                              <MediaViewer size="600px" :medias="editRecord.media" :traffic_record="{ plate_number_img: editRecord.plate_number_img }" />
                           </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="NOV">
                  <div class="row">
                    <div class="col-md-12 mb-1">
                      <div class="p-1">
                        <div v-if="editRecord.violation_penalties.length && editRecord.violation_penalties[0].generated_pdf_file_link" class="card-body overflow-auto">
                          <iframe :src="editRecord.violation_penalties[0].generated_pdf_file_link" height="800px" width="100%"></iframe>
                        </div>
                        <div class="p-2" v-else>
                          <h5>Notice of Violation (NOV) for this file name is not available!</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </b-overlay>
          </div>
          <div class="modal-footer">
            <button type="button" @click="resetEditRecord" class="btn btn-danger" data-bs-dismiss="modal">
              <i class="mdi mdi-close mr-1 align-middle"></i>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="voidRecordModal" class="modal fade" data-bs-backdrop="static" tabindex="-1" aria-labelledby="voidRecordModalLabel" aria-hidden="true" style="display: none;">
      <div class="modal-dialog modal-xl modal-fullscreen-lg-down">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editRecordModalLabel">Void Page</h5>
            <button type="button" @click="resetVoidRecord" class="btn-close" data-bs-dismiss="modal" aria-label="Close"> </button>
          </div>
          <div class="modal-body">
            <b-overlay :show="loading">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-12 text-center">
                      <h3>File No: {{ voidRecord.filename ? voidRecord.filename || 'n/a' : 'n/a'  }}</h3>
                    </div>
                    <div class="col-md-12 col-xl-6">
                      <div class="row">
                        <div class="col-md-12">
                          <template v-if="void_violation_information">
                            <ViolationInformation :violation_information="void_violation_information"></ViolationInformation>
                          </template>
                        </div>
                         <div class="col-md-12">
                          <template v-if="void_violations">
                            <Violations :violations="void_violations"></Violations>
                          </template>
                        </div>
                      </div>
                    </div>
                     <div class="col-md-12 col-xl-6">
                        <template v-if="void_lto_record_information">
                          <LtoRecord :lto_record="void_lto_record_information"></LtoRecord>
                        </template>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="border border-light p-2 fs-10 text">
                    <div class="text-danger border border-light p-2">* Voided records will not be include in delivery (Manifest/RC/PDF)</div>
                    <div class="text-danger border border-light p-2">* Voided records will not appear in payment tab</div>
                    <div class="text-danger border border-light p-2">* Apprehension of this record will be lifted</div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-header text-center">
                      <h4 class="card-title text-danger">Void</h4>
                    </div>
                    <div class="card-body">
                      <form v-if="!voidRecord.void && voidRecord.vehicle_record.length" @submit.prevent="voidThisTrafficRecord">
                        <div class="mb-3">
                          <label for="reasonNote" class="form-label text-danger">Reason/Note:</label>
                          <input type="text" v-model="note" class="form-control" id="reasonNote" placeholder="Enter reason/note here...">
                        </div>
                        <div class="mb-3">
                          <label for="attachFile" class="form-label text-danger">Attach File</label>
                          <input type="file" ref="attachmentRef" @change="handleFileUpload" class="form-control" id="attachFile">
                        </div>
                        <div class="mb-3">
                          <label for="EndleaveDate" class="form-label text-danger">Void/Lift Reason</label>
                          <select class="form-select" v-model="lift_reason_id">
                            <option value="1">Voided by LGU</option>
                            <option value="2">Voided by Adjudication Board</option>
                            <option value="3">Duplicate Violation</option>
                            <option value="4">Reject</option>
                          </select>
                        </div>
                        <div class="text-center">
                        <button type="submit" class="btn btn-danger">
                          <i class="mdi mdi-close mr-1 align-middle"></i>
                          Void this Traffic Record</button>
                        </div>
                      </form>
                      <form v-else-if="voidRecord.void && voidRecord.vehicle_record.length" @submit.prevent="voidThisTrafficRecord">
                        <div class="row mb-3">
                          <div class="col-lg-3">
                            <label for="reasonNote1" class="form-label">Reason/Note</label>
                          </div>
                          <div class="col-lg-9">
                            <input disabled readonly type="text" v-model="note" class="form-control" id="reasonNote1">
                          </div>
                        </div>
                        <div class="row mb-3" v-if="lift_reason_id">
                           <div class="col-lg-3">
                            <label class="form-label">Lift Reason</label>
                          </div>
                           <div class="col-lg-9">
                             <select class="form-select" v-model="lift_reason_id" disabled>
                              <option value="1">Voided by LGU</option>
                              <option value="2">Voided by Adjudication Board</option>
                              <option value="3">Duplicate Violation</option>
                              <option value="4">Reject</option>
                            </select>
                          </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-lg-3">
                            <label class="form-label">Voided By</label>
                          </div>
                          <div class="col-lg-9">
                            <span class="form-control bg-light">{{ voidRecord.void.voided_by_user ? voidRecord.void.voided_by_user : 'n/a' }}</span>
                          </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-lg-3">
                            <label class="form-label">Voided Date</label>
                          </div>
                          <div class="col-lg-9">
                            <span class="form-control bg-light">{{ voidRecord.void.updated_at ? moment(voidRecord.void.updated_at).utcOffset('+0800').format('MMMM DD, YYYY hh:mm:ss A') : 'n/a' }}</span>
                          </div>
                        </div>
                         <div class="row mb-3">
                          <div class="col-lg-3">
                            <label for="attachFile1" class="form-label">Attach File</label>
                          </div>
                          <div class="col-lg-9">
                            <input type="file" ref="attachmentRef" @change="handleFileUpload" class="form-control" id="attachFile1">
                          </div>
                        </div>
                        <div class="text-end">
                        <button type="submit" class="btn btn-primary">
                          <i class="ri-save-2-fill fs-14 mr-1 valign-middle"></i>
                          Update Void Traffic Record</button>
                        </div>
                      </form>
                      <div v-else-if="!voidRecord.void && !voidRecord.vehicle_record.length">
                        <div class="d-flex justify-content-center mb-3">
                          <h4>This record cannot be voided. Voiding will be available after this record is verified.</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-overlay>
          </div>
          <div class="modal-footer">
            <button type="button" @click="resetVoidRecord" class="btn btn-danger" data-bs-dismiss="modal">
              <i class="mdi mdi-close mr-1 align-middle"></i>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
